/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type { HTTPValidationError, SeismicAnalysisEnabledDTO } from '../fastAPI.schemas'

/**
 * @summary Get Seismic Analysis Enabled
 */
export const getSeismicAnalysisEnabled = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<SeismicAnalysisEnabledDTO>({
    url: `/projects/${projectGuid}/seismic-analysis-enabled`,
    method: 'GET',
    signal,
  })
}

export const getGetSeismicAnalysisEnabledQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/seismic-analysis-enabled`] as const
}

export const getGetSeismicAnalysisEnabledQueryOptions = <
  TData = Awaited<ReturnType<typeof getSeismicAnalysisEnabled>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSeismicAnalysisEnabled>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetSeismicAnalysisEnabledQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSeismicAnalysisEnabled>>> = ({
    signal,
  }) => getSeismicAnalysisEnabled(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSeismicAnalysisEnabled>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetSeismicAnalysisEnabledQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSeismicAnalysisEnabled>>
>
export type GetSeismicAnalysisEnabledQueryError = HTTPValidationError

/**
 * @summary Get Seismic Analysis Enabled
 */

export function useGetSeismicAnalysisEnabled<
  TData = Awaited<ReturnType<typeof getSeismicAnalysisEnabled>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getSeismicAnalysisEnabled>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSeismicAnalysisEnabledQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * Sets the flag and nothing else.

The configuration, the model inputs and the results are kept, so switching
the analysis back on restores the model that was calculated before.
Saving model inputs or results turns the flag on again by itself.
 * @summary Set Seismic Analysis Enabled
 */
export const setSeismicAnalysisEnabled = (
  projectGuid: string,
  seismicAnalysisEnabledDTO: SeismicAnalysisEnabledDTO,
) => {
  return customInstance<SeismicAnalysisEnabledDTO>({
    url: `/projects/${projectGuid}/seismic-analysis-enabled`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: seismicAnalysisEnabledDTO,
  })
}

export const useSetSeismicAnalysisEnabledMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setSeismicAnalysisEnabled>>,
    TError,
    { projectGuid: string; data: SeismicAnalysisEnabledDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setSeismicAnalysisEnabled>>,
  TError,
  { projectGuid: string; data: SeismicAnalysisEnabledDTO },
  TContext
> => {
  const mutationKey = ['setSeismicAnalysisEnabled']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setSeismicAnalysisEnabled>>,
    { projectGuid: string; data: SeismicAnalysisEnabledDTO }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return setSeismicAnalysisEnabled(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/seismic-analysis-enabled` },
    {
      operationId:
        'set_seismic_analysis_enabled_projects__project_guid__seismic_analysis_enabled_put',
      operationName: 'setSeismicAnalysisEnabled',
    },
  )

  return customOptions
}

export type SetSeismicAnalysisEnabledMutationResult = NonNullable<
  Awaited<ReturnType<typeof setSeismicAnalysisEnabled>>
>
export type SetSeismicAnalysisEnabledMutationBody = SeismicAnalysisEnabledDTO
export type SetSeismicAnalysisEnabledMutationError = HTTPValidationError

/**
 * @summary Set Seismic Analysis Enabled
 */
export const useSetSeismicAnalysisEnabled = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setSeismicAnalysisEnabled>>,
    TError,
    { projectGuid: string; data: SeismicAnalysisEnabledDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setSeismicAnalysisEnabled>>,
  TError,
  { projectGuid: string; data: SeismicAnalysisEnabledDTO },
  TContext
> => {
  const mutationOptions = useSetSeismicAnalysisEnabledMutationOptions(options)

  return useMutation(mutationOptions)
}
